/**
 * Lightweight date formatting utility to replace moment.js.
 * Supports common format patterns used in this project.
 */
export function formatDate(value: string | Date, format: string): string {
    const normalized = typeof value === 'string' ? value.replace(/-/g, '/') : value;
    const date = normalized instanceof Date ? normalized : new Date(normalized);
    if (isNaN(date.getTime())) return '';

    switch (format) {
        case 'MM/DD/YYYY':
            return pad(date.getMonth() + 1) + '/' + pad(date.getDate()) + '/' + date.getFullYear();
        case 'YYYY-MM-DD':
            return date.getFullYear() + '-' + pad(date.getMonth() + 1) + '-' + pad(date.getDate());
        case 'MMM DD':
            return date.toLocaleDateString('en-US', { month: 'short', day: '2-digit' });
        case 'D MMMM YYYY':
            return date.toLocaleDateString('en-US', { day: 'numeric', month: 'long', year: 'numeric' });
        default:
            return date.toLocaleDateString('en-US');
    }
}

function pad(n: number): string {
    return n < 10 ? '0' + n : '' + n;
}
